import ResourceDetails from './ResourceDetails';
export default ResourceDetails;
